import Vue from 'vue'

import { Row, Col, Descriptions, Button, Icon, Result } from 'ant-design-vue'
// import 'ant-design-vue/lib/row/style'
// import 'ant-design-vue/lib/col/style'
// import 'ant-design-vue/lib/descriptions/style'
// import 'ant-design-vue/lib/button/style'
// import 'ant-design-vue/lib/icon/style'

import App from './App.vue'
import router from './router'
// import store from './store'

Vue.config.productionTip = false
Vue.use(Row)
Vue.use(Col)
Vue.use(Descriptions)
Vue.use(Button)
Vue.use(Icon)
Vue.use(Result)

new Vue({
  router,
  // store,
  render: h => h(App)
}).$mount('#app')
